import React from 'react';
import { IpaType } from '../../phonemes/ipa';
import { sonorityCat1, sonorityCat2, sonorityCat3, sonorityCat4 } from '../../phonotactics/orderBySonority';

interface SonorityProps {
  /** segments sorted by sonority */
  readonly sonorityList: IpaType[];
}

/**
 * shows segments sorted by sonority,
 * along with various abbreviations for categories they belong to
 */
export function Sonority(props: SonorityProps) {
  return (<table>
    <tbody>
      {props.sonorityList.map((item, i) => {
        if (item.length === 0) {
          return undefined;
        }
        return <tr key={i}>
          <td>{item}</td>
          <td>{sonorityCat4[i]}</td>
          <td>{sonorityCat3[i]}</td>
          <td>{sonorityCat2[i]}</td>
          <td>{sonorityCat1[i]}</td>
        </tr>;
      })}
    </tbody>
  </table>);
}
